// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---customer-vivany-page-template-files-page-tsx": () => import("./../../../customer/Vivany/page-template/files-page.tsx" /* webpackChunkName: "component---customer-vivany-page-template-files-page-tsx" */),
  "component---customer-vivany-page-template-free-estimation-page-tsx": () => import("./../../../customer/Vivany/page-template/free-estimation-page.tsx" /* webpackChunkName: "component---customer-vivany-page-template-free-estimation-page-tsx" */)
}

